export default __webpack_public_path__ + "d41beab341812666244acf65a9c58d86.svg";